import { getAvatarUrl } from "~/lib/imageUrl";
import { parseTimestamp } from "~/utils/parseTimestamp";
import type { Conversation, ConversationApiItem } from "../types";
import { hasMediaMark } from "./mediaMark";

export const toConversation = (item: ConversationApiItem): Conversation => {
  return {
    id: item.frd_id,
    partnerId: item.frd_id,
    partnerName: item.frd_name,
    partnerAvatar: getAvatarUrl(item.ava_id),
    lastMessage: item.last_msg,
    lastMsgType: item.msg_type,
    lastMessageAt: parseTimestamp(item.sent_time)?.toISOString() ?? null,
    unreadCount: item.unread_num,
    isOwn: item.is_own ?? false,
    age: typeof item.age === "number" && item.age > 0 ? item.age : null,
    region:
      typeof item.region === "number" && item.region > 0 ? item.region : null,
    isOnline: item.is_online ?? false,
    lastLoginTime: item.last_login_time ?? item.lastLoginTime ?? null,
    hasMedia: hasMediaMark(item.msg_type, item.one_before_msg_type),
  };
};
